<template>
    <div class="card-toggle" :class="{'active': opened}">
        <div class="card-toggle-head" @click="opened=!opened">
            {{title}}
            <i class="fa" :class="(opened) ? 'fa-chevron-up' : 'fa-chevron-down'" />
        </div>
        <div class="card-toggle-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CardToggle',

        props: ['title'],

        data: () => ({
            opened: false
        }),
    }
</script>
